import { useEffect, useRef } from 'react';

const useUpdateTitle = (unreadCount: number) => {
    const baseTitleRef = useRef(document.title.replace(/\(\d+\)\s/, ''));

    useEffect(() => {
        if (unreadCount > 0) {
            document.title = `(${unreadCount}) ${baseTitleRef.current}`;
        } else {
            document.title = baseTitleRef.current;
        }
    }, [unreadCount]);
};

export default useUpdateTitle;
